import script from "./ContactView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactView.vue?vue&type=script&setup=true&lang=ts"

import "./ContactView.vue?vue&type=style&index=0&id=30156997&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30156997"]])

export default __exports__